import { createAction, props } from "@ngrx/store";

import { PaginationRequest } from "src/app/models/common/paginationRequest";
import { DictionaryAsPropertiesDTO } from "src/app/models/languages-management/dictionaryAsPropertiesDTO";

// Dictionary
export const getDictionaryList = createAction(
  "[Dictionary] Get All Dictionary List Action",
  props<{ options: any }>()
);
export const loadDictionaryList = createAction(
  "[Dictionary] Load All Dictionary List Action",
  props<{ response: any }>()
);

// Excel Dictionary List
export const getDictionaryExcelList = createAction(
  "[Dictionary] Get All Dictionary Excel List Action",
  props<{ options: any }>()
);
export const loadDictionaryExcelList = createAction(
  "[Dictionary] Load All Dictionary Excel List Action",
  props<{ response: any[] }>()
);

// Dictionary Properties
export const getPropertiesForListByUsage = createAction(
  "[Dictionary] Get All Dictionary Properties Action",
  props<{ usageCode: string }>()
);
export const loadPropertiesForListByUsage = createAction(
  "[Dictionary] Load All Dictionary Properties Action",
  props<{ response: any[] }>()
);
export const getPropertiesByUsage = createAction(
  "[Dictionary] Get All Properties by Usage Action",
  props<{ pageReq: PaginationRequest; usageCode: string }>()
);
export const loadPropertiesByUsage = createAction(
  "[Dictionary] Load All Properties by Usage Action",
  props<{ response: any[] }>()
);

// Dictionary
export const getDictionary = createAction(
  "[Dictionary] Get Dictionary Action",
  props<{ id: string }>()
);
export const loadDictionary = createAction(
  "[Dictionary] Load Dictionary Action",
  props<{ dictionary: DictionaryAsPropertiesDTO }>()
);
export const createDictionary = createAction(
  "[Dictionary] Create Dictionary Action",
  props<{ dictionary: DictionaryAsPropertiesDTO }>()
);
export const updateDictionary = createAction(
  "[Dictionary] Update Dictionary Action",
  props<{ dictionary: DictionaryAsPropertiesDTO }>()
);
export const deleteDictionary = createAction(
  "[Dictionary] Delete Dictionary Action",
  props<{ id: string }>()
);
export const deletedDictionarySuccessfully = createAction(
  "[Dictionary] Deleted Dictionary Successfully Action"
)

// Loading Actions
export const getLoadingDictionaryState = createAction(
  "[Dictionary] Get Contracts Loading State Action"
);
export const setLoadingDictionaryStartState = createAction(
  "[Dictionary] Set Contracts Loading Start State Action"
);
export const setLoadingDictionaryEndState = createAction(
  "[Dictionary] Set Contracts Loading End State Action"
);

// Dictionary Table Configuration Settings
export const getDictionaryTableConfig = createAction(
  "[Dictionary] Get Dictionary Table Configuration Action",
  props<{ options: any }>()
);
export const loadDictionaryTableConfig = createAction(
  "[Dictionary] Load Dictionary Table Configuration Action",
  props<{ response: any[] }>()
);
export const saveDictionaryTableConfig = createAction(
  "[Dictionary] Save Dictionary Table Configuration Action",
  props<{ config: any }>()
);

// Reset
export const resetDictionaryState = createAction(
  "[Dictionary] Reset Dictionary State Action"
);
export const resetCreation = createAction("[Dictionary] Reset Creation Action");
